export default __webpack_public_path__ + "enterprise-boundaries-xray-480-c65bea450b31debe4277c3d5a8a3bb18.png";